<!--
 * @FileDescription: 客户管理——客户列表（注释描述）
 * @Author: ryb（作者）
 * @Date: 2020-04-13（时间）
 * @LastEditors: ryb（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
  <div class="client-list-page">
    <div class="client-list-page-screen">
      <a-form layout="inline">
        <a-form-item>
          <a-select labelInValue
                    style="width: 200px"
                    placeholder="区域选择"
                    @change="handleChange">
            <a-icon slot="suffixIcon"
                    type="caret-down"
                    style="color: #555555" />
            <a-select-option value="jack"
                             v-for="(item, index) in selectList"
                             :key="index"></a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-select labelInValue
                    style="width: 200px"
                    placeholder="客户级别"
                    @change="handleChange">
            <a-icon slot="suffixIcon"
                    type="caret-down"
                    style="color: #555555" />
            <a-select-option value="jack"
                             v-for="(item, index) in selectList"
                             :key="index"></a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-input placeholder="请输入关键词查询"
                   class="filter-input"
                   style="width: 260px" />
        </a-form-item>
        <a-button type="primary"
                  class="border-arc input-botton">搜索</a-button>
        <a-button  type="primary" icon="plus"
                  @click="addClient" style="float:right">新增默认</a-button>
      </a-form>
    </div>
    <div class="client-list-page-content">
      <div class="client-list-box"
           v-for="(item, index) in 10"
           :key="index">
        <card-temp :width="368"
                   :height="204">
          <div class="client-information">
            <div class="client-name">
              <span class="name">张三</span>
              <span class="phone">13856662585</span>
              <span class="lable">VIP客户</span>
            </div>
            <div class="client-list">
              <div class="client-serial">
                <img src="@/assets/image/dizhitianchong1@2x.png"
                     alt=""
                     class="icon-image">
                <span class="title-text">客户编号</span>
                <span class="value-text">20200422</span>
              </div>
              <div class="client-area">
                <img src="@/assets/image/dizhitianchong1@2x.png"
                     alt=""
                     class="icon-image">
                <span class="title-text">客户区域</span>
                <span class="value-text">浙江省</span>
              </div>
              <div class="client-num">
                <img src="@/assets/image/dizhitianchong1@2x.png"
                     alt=""
                     class="icon-image">
                <span class="title-text">成交次数</span>
                <span class="value-text">125</span>
              </div>
              <div class="client-price">
                <img src="@/assets/image/dizhitianchong1@2x.png"
                     alt=""
                     class="icon-image">
                <span class="title-text">消费金额</span>
                <span class="value-text">13698</span>
              </div>
            </div>
            <div class="look-edit">
              <!-- <span class="look">查看</span> -->
              <span class="edit"
                    @click="editClient">编辑</span>
            </div>
          </div>
        </card-temp>
      </div>
    </div>
    <client-modules ref="clientModules"></client-modules>
  </div>
</template>
<script>
import cardTemp from "@/components/card-temp.vue"
import clientModules from "./modules/clientModules.vue"
export default {
  name: "clientList",
  data () {
    return {
      selectList: [],
      queryParam: {}
    }
  },
  components: {
    cardTemp,
    clientModules
  },
  mounted () {

  },
  methods: {
    /**
    * @description: 退出登录（方法描述）
    * @param {参数类型} 参数名称
    * @return void
    */
    handleChange (e) {
      console.log(e)
    },
    // 添加数据
    addClient () {
    //   this.$refs.clientModules.add()
        this.$store.state.fourPath = '/shoprun/clientmanage/clientDetails'
        this.$router.push('/shoprun/clientmanage/clientDetails') 
    },
    editClient () {
      this.$refs.clientModules.edit()
    }
  },
  watch: {

  }
}
</script>
<style lang="scss">
.client-list-page {
  .client-list-page-screen {
    display: flex;
    flex-wrap: wrap;
    margin: 10px 12px 15px 2px;
    .ant-form {
      width: 100%;
    }
    .btn-add-default {
      float: right;
    }
  }
  .client-list-page-content {
    margin-left: 12px;
    display: flex;
    flex-wrap: wrap;
    .client-information {
      margin: 10px 26px 20px 44px;
      .client-name {
        height: 62px;
        display: flex;
        align-items: center;
        font-size: 14px;
        .name {
          color: #333333;
        }
        .phone {
          color: #555555;
          margin: 0 12px;
        }
        .lable {
          display: inline-block;
          width: 60px;
          height: 22px;
          background: rgba(253, 86, 33, 0.1);
          border-radius: 11px;
          font-size: 12px;
          color: #fd5621;
          text-align: center;
          line-height: 22px;
        }
      }
      .client-list {
        height: 84px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .client-serial,
        .client-area,
        .client-num,
        .client-price {
          height: 21px;
          display: flex;
          align-items: center;
          font-size: 14px;
          .icon-image {
            // width: 12px;
            height: 12px;
          }
          .title-text {
            color: #aaaaaa;
            margin: 0 18px 0 10px;
          }
          .value-text {
            color: #555555;
          }
        }
      }
      .look-edit {
        text-align: right;
        margin-top: 16px;
        color: var(--co);
        .look {
          cursor: pointer;
          margin-right: 18px;
        }
        .edit {
          cursor: pointer;
        }
      }
    }
  }
}
</style>
